import {WarningIcon} from '../../../../icons'
import {colors} from '../../../../utils/colors'
import Tooltip from '../../../core/tooltip'

const ResourceState = ({tooltipText, interactive = false, icon = null, placement = ''}) => {
    return (
        <Tooltip content={tooltipText} placement={placement || 'right'} trigger='mouseenter' interactive={interactive} noButton>
            {icon || <WarningIcon stroke={colors.colorOrange} width={20} height={20}/>}
        </Tooltip>
    )
}

export default ResourceState
